import { getUser } from "@api/authorization";
import { createRegisteredAsOwnerOrMemberQuery } from "@api/solid-query/event";
import LoadingSpinner from "@components/LoadingSpinner";
import type { EventModelWithCounts } from "@road-rally/backend-api/backend-types";
import { For, Show, createMemo } from "solid-js";
import { EventCard } from "./EventCard";

const formatDate = (date: Date, timeZone: string) =>
  date
    .toLocaleDateString("en-US", {
      timeZone: timeZone,
      year: "numeric",
      month: "numeric",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
    })
    .replace(",", " ");

export const EventList = (props: { events: EventModelWithCounts[] }) => {
  const registeredEventsQuery = createRegisteredAsOwnerOrMemberQuery();
  const registeredEventIds = createMemo(
    () => new Set(registeredEventsQuery.data ?? [])
  );

  const user = getUser();

  const isRegistered = (eventId: number) => {
    return registeredEventIds().has(eventId);
  };

  return (
    <Show
      when={registeredEventsQuery.isFetched || !user}
      fallback={<LoadingSpinner />}
    >
      <div class="mt-4 w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        <For each={props.events}>
          {(event) => {
            const timeZone = event?.timezone || "America/Denver";
            const start = new Date(event.startTime);
            const end = new Date(event.endTime);
            const started = start < new Date();
            const ended = end < new Date();
            const live = started && !ended;
            const date = (() => {
              if (live) return `Ends ${formatDate(end, timeZone)}`;
              if (ended)
                return start.toLocaleDateString("en-US", {
                  timeZone: timeZone,
                  month: "numeric",
                  day: "numeric",
                  year: "numeric",
                });
              return formatDate(start, timeZone);
            })();
            return (
              <EventCard
                id={event.id}
                private={event.private}
                photoSRC={event.image}
                title={event.name}
                date={date}
                live={live}
                location={event.city + ", " + event.state + " " + event.country}
                currentJackpot={event.currentJackpot}
                registered={isRegistered(event.id)}
              />
            );
          }}
        </For>
      </div>
    </Show>
  );
};

export default EventList;
